/* ===== MODHAX TOP — 1 ジェスチャー = 1 セクション移動 =====
   ・PC（細かいポインタ）：ホイール 1 ノッチ = 1 セクション
   ・モバイル（粗いポインタ）：一切乗っ取らない。ネイティブスクロール＋慣性のまま。
     → touchstart / touchmove / touchend は「そもそも登録しない」。
       登録しなければ preventDefault も起きないので、指の動きは完全に素のまま。
   ・280ms の自前トゥイーン（rAF / ease-out）＋終了後 80ms のクールダウン
   ・SECRET から下（＝フッター方向）は一切乗っ取らない（ネイティブスクロール）
   ・SECRET から上は乗っ取る（ABOUT US へ）。フッター域にいるときは
     まず SECRET の先頭へ戻り、次のジェスチャーで ABOUT US へ。
   ・右のドット（.mx-nav button）も同じルーチンを使う（実装を 1 本化）。
     modhax.js は編集せず、キャプチャフェーズで click を先取りして差し替える。
     ※ .mx-nav はモバイルでは CSS で非表示なので、実質 PC 専用。

   【ポインタ判定】
   ・matchMedia('(pointer: coarse)') が真 = タッチ主体 → タッチ乗っ取りなし。
   ・読み込み時に 1 回だけ決めるのではなく、change / resize で常に追従する。
     （デスクトップのウィンドウを細くした／ハイブリッド機でマウスを抜き差しした、
       といった場合に古い挙動が残らないようにするため）

   【カクツキ対策】
   (a) トゥイーン中はレイアウト読み取りを一切しない（目標値は開始時に 1 回だけ測る）。
   (b) トゥイーン中は <html> に .mx-snapping を付け、追従ヘッダーなど
       スクロール連動のアニメーションとバウンスを CSS 側で凍結させる。
   (c) モバイル WebView（LINE アプリ内ブラウザ等）対策：
       ・ツールバーの開閉で innerHeight / 文書高がトゥイーン中に変わると
         目標 Y が飛行中にズレる。→ 終了時に一度だけ測り直して補正する。
       ・フッター → SECRET の戻りだけはタッチ端末ではトゥイーンせず即移動。
       ・トゥイーン開始後は touchmove で preventDefault しない。
*/
(function () {
  'use strict';
  if (window.__mxSnap) return;

  var secs = [];
  var secretIdx = -1;
  var locked = false;          // アニメーション＋クールダウン中
  var DURATION = 280;
  var COOLDOWN = 80;
  var TOL = 4;                 // 先頭判定の許容誤差(px)

  function reduce() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* UA 判定はしない。「粗いポインタ＝タッチ」で見る */
  function isTouch() {
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return true;
    return ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
  }

  function collect() {
    secs = Array.prototype.slice.call(document.querySelectorAll('.mx-sec'));
    secretIdx = -1;
    for (var i = 0; i < secs.length; i++) {
      if (secs[i].classList.contains('mx-sec--secret')) secretIdx = i;
    }
    return secs.length >= 2;
  }

  function topOf(el) {
    return Math.round(el.getBoundingClientRect().top + window.pageYOffset);
  }
  function maxScroll() {
    return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  }
  function clampY(y) {
    return Math.max(0, Math.min(y, maxScroll()));
  }

  /* 現在位置がどのセクションの領域にいるか
     ※ レイアウト読み取りを含むので locked 中には絶対に呼ばない */
  function currentIndex() {
    var y = window.pageYOffset;
    var idx = 0;
    for (var i = 0; i < secs.length; i++) {
      if (y >= topOf(secs[i]) - TOL) idx = i;
    }
    return idx;
  }

  /* 「SECRET の先頭より下（＝フッター側）にいるか」 */
  function isBelowSecretTop() {
    if (secretIdx < 0) return false;
    return window.pageYOffset > topOf(secs[secretIdx]) + TOL;
  }

  /* ---------- トゥイーン ---------- */
  function easeOutCubic(p) {
    var q = 1 - p;
    return 1 - q * q * q;
  }

  function setSnapping(on) {
    var c = document.documentElement.classList;
    if (on) c.add('mx-snapping');
    else c.remove('mx-snapping');
  }

  function unlock() {
    setSnapping(false);
    setTimeout(function () { locked = false; }, COOLDOWN);
  }

  /* 要素へ飛ぶ。instant=true なら補間なしで一発で合わせる。
     レイアウト読み取りは「開始時」と「終了時の補正」の 2 回だけ。 */
  function jumpTo(el, instant) {
    if (!el) return;

    var targetY = clampY(topOf(el));
    var startY = window.pageYOffset;
    var dy = targetY - startY;
    if (Math.abs(dy) < 1) return;

    locked = true;
    setSnapping(true);

    /* 開始時のビューポート・文書高を覚えておく
       （モバイル WebView はツールバー開閉でこれらが途中で変わる） */
    var h0 = document.documentElement.scrollHeight;
    var vh0 = window.innerHeight;

    function settle() {
      /* 途中でビューポートが変わっていたら、そのときだけ測り直して
         一発で補正する（フレーごとの再計算はしない） */
      if (document.documentElement.scrollHeight !== h0 || window.innerHeight !== vh0) {
        var fixed = clampY(topOf(el));
        if (Math.abs(fixed - window.pageYOffset) > 1) window.scrollTo(0, fixed);
      }
      unlock();
    }

    if (instant || reduce()) {
      window.scrollTo(0, targetY);
      settle();
      return;
    }

    var t0 = null;
    function step(now) {
      if (t0 === null) t0 = now;
      var p = (now - t0) / DURATION;
      if (p >= 1) {
        window.scrollTo(0, targetY);
        settle();
        return;
      }
      window.scrollTo(0, Math.round(startY + dy * easeOutCubic(p)));
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function goTo(el) { jumpTo(el, false); }

  /* ---------- 乗っ取らない条件 ---------- */
  var SKIP_SEL = [
    'input', 'textarea', 'select', 'option', '[contenteditable]',
    '.mx-spell',            // 呪文入力欄
    '.mx-chapters',         // ABOUT US の横スクロールパネル
    '.mx-modal',            // キャラ詳細モーダル
    '.mx-spellfx',          // 命文ミス演出
    '.mhx-drawer', '#mhxDrawer', '#mhxSearchDrawer',
    'cart-drawer', '.cart-drawer', '.drawer', '.menu-drawer',
    '.mx-nav'
  ].join(',');

  function inSkipZone(node) {
    if (node && node.nodeType !== 1) node = node.parentElement;
    if (!node || !node.closest) return false;
    return !!node.closest(SKIP_SEL);
  }

  function overlayOpen() {
    if (document.querySelector('.mx-spellfx:not([hidden])')) return true;
    if (document.querySelector('.mx-modal:not([hidden])')) return true;
    if (document.querySelector('.mhx-drawer.is-open, #mhxDrawer.is-open, #mhxSearchDrawer.is-open')) return true;
    if (document.querySelector('.drawer.is-open, cart-drawer.active, .cart-drawer.active')) return true;
    if (document.body.style.overflow === 'hidden') return true;
    if (document.documentElement.classList.contains('mx-spellfx-lock')) return true;
    if (document.body.classList.contains('mx-spellfx-lock')) return true;
    return false;
  }

  /* この方向のジェスチャーをどうするか
     戻り値：null = 乗っ取らない（ネイティブ）
            { el: 行き先, back: フッター→SECRET の戻りかどうか }
     ※ レイアウト読み取りを含むので locked 中には呼ばない */
  function resolve(dir) {
    if (secs.length < 2) return null;
    var idx = currentIndex();

    if (dir > 0) {
      /* 下方向：SECRET 領域以降は一切乗っ取らない（フッターに行けるように） */
      if (secretIdx >= 0 && idx >= secretIdx) return null;
      if (idx >= secs.length - 1) return null;
      return { el: secs[idx + 1], back: false };
    }

    /* 上方向 */
    if (isBelowSecretTop()) return { el: secs[secretIdx], back: true };  // まず SECRET の先頭へ
    if (idx <= 0) return null;                                          // 一番上ならネイティブ
    return { el: secs[idx - 1], back: false };
  }

  /* フッター → SECRET の戻りは、タッチ端末ではトゥイーンせず即移動。
     （WebView のツールバー開閉でビューポートが伸び縮みする区間なので、
       補間すると目標がズレてガクガクする。元の位置への復帰なので
       即移動でも違和感はない）
     ※ 粗いポインタ端末ではタッチ経路自体が無効なので、ここに来るのは
       .mx-nav 経由（タッチ操作もできる細ポインタ機など）のときだけ。 */
  function runMove(mv) {
    if (!mv) return;
    jumpTo(mv.el, mv.back && isTouch());
  }

  function canHijack(e) {
    if (!secs.length) return false;
    if (e && (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey)) return false;
    if (overlayOpen()) return false;
    if (e && inSkipZone(e.target)) return false;
    return true;
  }

  /* ---------- ホイール（PC） ---------- */
  function onWheel(e) {
    if (locked) {
      /* トゥイーン中は測らずに惿性を食うだけ */
      if (e.cancelable) e.preventDefault();
      return;
    }
    if (!canHijack(e)) return;

    var dir = e.deltaY > 0 ? 1 : (e.deltaY < 0 ? -1 : 0);
    if (!dir) return;

    var mv = resolve(dir);
    if (!mv) return;          // ネイティブに任せる

    e.preventDefault();
    jumpTo(mv.el, false);     // PC は常にトゥイーン
  }

  /* ---------- スワイプ（細かいポインタの端末のみ） ---------- */
  var tStartY = 0, tStartT = 0, armed = false, touchSkip = true;
  var SWIPE_MIN = 40, SWIPE_MS = 600;

  function onTouchStart(e) {
    armed = false;
    /* トゥイーン中に触られたら何もしない（preventDefault もしない）。
       WebView では飛行中の preventDefault 連発がカクツきの原因になる。 */
    if (locked) { touchSkip = true; return; }
    touchSkip = !canHijack(e) || e.touches.length > 1;
    if (touchSkip) return;
    tStartY = e.touches[0].clientY;
    tStartT = Date.now();
  }

  function onTouchMove(e) {
    if (touchSkip || locked) return;   // 乗っ取らない／飛行中は即抜け

    var dy = e.touches[0].clientY - tStartY;

    if (!armed) {
      if (Math.abs(dy) < 8) return;                       // 方向が確定するまでは何もしない
      var dir = dy < 0 ? 1 : -1;                          // 指を上に動かす = 下へ進む
      if (!resolve(dir)) { touchSkip = true; return; }    // ネイティブに譲る
      armed = true;
    }
    /* ジェスチャー認識中だけネイティブスクロールを抑える */
    if (e.cancelable) e.preventDefault();
  }

  function onTouchEnd(e) {
    if (touchSkip || !armed) { armed = false; return; }
    armed = false;
    if (locked) return;
    var dy = e.changedTouches[0].clientY - tStartY;
    var dt = Date.now() - tStartT;
    if (Math.abs(dy) < SWIPE_MIN || dt > SWIPE_MS) return;
    runMove(resolve(dy < 0 ? 1 : -1));
  }

  /* ---------- 粗いポインタ（＝スマホ・タブレット）ではタッチを登録しない ----------
     登録／解除を切り替える形にしておき、change / resize で常に追従させる。
     「読み込み時に 1 回だけ判定」にすると、ウィンドウを細くした場合や
     ハイブリッド機でポインタが変わった場合に古い挙動が残ってしまう。 */
  var coarseMQ = (window.matchMedia ? window.matchMedia('(pointer: coarse)') : null);
  var touchBound = false;

  function bindTouch() {
    if (touchBound) return;
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('touchend', onTouchEnd, { passive: true });
    touchBound = true;
  }

  function unbindTouch() {
    if (!touchBound) return;
    window.removeEventListener('touchstart', onTouchStart, { passive: true });
    window.removeEventListener('touchmove', onTouchMove, { passive: false });
    window.removeEventListener('touchend', onTouchEnd, { passive: true });
    /* 途中でモードが変わったときに中途半端な状態を残さない */
    touchSkip = true;
    armed = false;
    touchBound = false;
  }

  function syncPointerMode() {
    if (coarseMQ && coarseMQ.matches) unbindTouch();
    else bindTouch();
  }

  /* ---------- 右のドット（.mx-nav）を同じルーチンに差し替え ---------- */
  function onNavClickCapture(e) {
    var btn = e.target && e.target.closest ? e.target.closest('.mx-nav button') : null;
    if (!btn || !btn.parentNode) return;
    var idx = Array.prototype.indexOf.call(btn.parentNode.children, btn);
    if (idx < 0 || idx >= secs.length) return;
    e.stopPropagation();
    e.preventDefault();
    goTo(secs[idx]);
  }

  /* ---------- 初期化 ---------- */
  function boot() {
    if (!collect()) return;   // .mx-sec がない（TOP 以外）ページでは何もしない

    document.documentElement.style.scrollBehavior = 'auto';

    window.addEventListener('wheel', onWheel, { passive: false });
    syncPointerMode();        // 粗いポインタならタッチは登録されない
    document.addEventListener('click', onNavClickCapture, true);

    /* ポインタ種別の変化に追従する（古い WebView 用に addListener も見る） */
    if (coarseMQ) {
      if (coarseMQ.addEventListener) coarseMQ.addEventListener('change', syncPointerMode);
      else if (coarseMQ.addListener) coarseMQ.addListener(syncPointerMode);
    }

    window.addEventListener('resize', collect);
    window.addEventListener('resize', syncPointerMode);
    document.addEventListener('shopify:section:load', collect);
  }

  window.__mxSnap = {
    goTo: goTo,
    jumpTo: jumpTo,
    tweenTo: function (y) { window.scrollTo(0, clampY(y)); },
    refresh: collect
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', collect);
})();
